export default "__VITE_ASSET__B$c4Kahw__"